export const portfolioData = [
    {
        portfolioTypeId: 1,
        portfolioTypeName: "Business",
    },
    {
        portfolioTypeId: 2,
        portfolioTypeName: "Economy",
    },
    {
        portfolioTypeId: 3,
        portfolioTypeName: "Finance",
    },
    {
        portfolioTypeId: 4,
        portfolioTypeName: "Marketing",
    },
    {
        portfolioTypeId: 5,
        portfolioTypeName: "Technology",
    }
]

export const faqs = {
    heading: "Faqs",
    title: "Frequently Asked Questions"
}